import { getSharedAccountsUrl } from 'BomdisoftUtilities/shared-login';

const PRODUCTION_HUB_URL = 'https://bomdisoft.com';

const trimTrailingSlash = (url: string): string => url.replace(/\/+$/, '');

/**
 * Resolve a public platform origin, refusing to guess during development.
 *
 * A production fallback keeps a live build from ever shipping a dead link, but
 * applying it everywhere hid a worse failure than a dead link: a developer
 * testing locally was silently sent to the production host, which looks like it
 * works. So the fallback is production-only, and a development build says which
 * variable is missing instead.
 */
export const resolvePlatformOrigin = (name: string, value: string | undefined, productionFallback: string): string => {
  if (value) {
    return trimTrailingSlash(value);
  }
  if (process.env.NODE_ENV === 'development') {
    throw new Error(`${name} is not set. A development build must not fall back to the production host; set it in your local environment.`);
  }
  return productionFallback;
};

/** Public origin of the bomdisoft.com hub. */
export const getSharedHubUrl = (): string => resolvePlatformOrigin('NEXT_PUBLIC_BOMDISOFT_HUB_URL', process.env.NEXT_PUBLIC_BOMDISOFT_HUB_URL, PRODUCTION_HUB_URL);

/**
 * Destination for a product's Billing entry in the shared account menu: the
 * Bomdisoft ID console's `/billing` section.
 *
 * The console's billing section is the destination. The login app's
 * `/account/billing` path still redirects there while environments transition.
 */
export const getSharedBillingUrl = (): string => {
  const configured = process.env.NEXT_PUBLIC_BOMDISOFT_BILLING_URL;
  return configured ? trimTrailingSlash(configured) : `${getSharedAccountsUrl()}/billing`;
};
